import React, {forwardRef, useEffect} from "react";
import styles from "./LessonInstruction.module.css";
import avatar from "./../../assets/images/instruction-avatar.webp";

import PlayButton from "../../components/PlayButton/PlayButton";
import useAudioPlayback from "../../hooks/useAudioPlayback";
import { getLanguagePack } from "../../service/service";

const LessonInstruction = forwardRef(({ instructionText, audioUrl }, ref) => {
  const languagePack = getLanguagePack();
  const translatedInstruction = languagePack[instructionText] || instructionText;

  const { state, togglePlayback } = useAudioPlayback(audioUrl, 'instruction');

  const handlePlayPause = () => {
    togglePlayback();
  };

  return (
    <>
      <div className={styles.instructionContainer}>
        <div className={styles.instructionContent}>
          <div className={styles.instruction}>
            <div className={styles.avatar}>
              <img src={avatar} alt="Avatar" />
            </div>
            <p className={styles.instructionText}>{translatedInstruction}</p>
          </div>

          <PlayButton isPlaying={state === 'playing'} onClick={handlePlayPause} />

        </div>
      </div>
    </>
  );
});

export default LessonInstruction;